import { gql } from '@apollo/client';

export const getCurrencies = gql`
    {
      getCurrencies {
        id
        symbol
        isEnable
        isPayment
        isBaseCurrency
        status
      }
    }
`;

export const getCurrencyRates = gql`{
  getCurrencyRates {
      base
      rates
  }
}`;

export const getAllAdminRolesQuery = gql`{
  getAllAdminRoles {
    results{
      id
      name
      description
      createdAt
      updatedAt
      privileges
    }
  }
}`;

export const createAdminRoleQuery = gql`
  mutation ($id: Int, $name: String!, $description: String, $privileges: [Int]!) {
    createAdminRole (id: $id, name: $name, description: $description, privileges: $privileges) {
        status
        errorMessage
}
}`;

export const deleteAdminQuery = gql`
mutation ($id: Int!) {
  deleteAdminRole(id: $id) {
      status
      errorMessage
  }
}`;

export const getPrivilegesQuery = gql`
query {
  getPrivileges {
      results{
        id
        name
        permittedUrls
      }
      status
      errorMessage
  }
}`;

export const createAdminUserMutation = gql`
mutation ($id: String, $email: String!, $password: String, $roleId: Int!) {
  createAdminUser (id: $id, email: $email, password: $password, roleId: $roleId) {
  status
  errorMessage
  }
}`;

export const deleteAdminUserMutation = gql`
mutation ($id: String!) {
  deleteAdminUser (id: $id) {
  status
  errorMessage
  }
}`;

export const getAdminUserQuery = gql`
query {
  getAdminUser {
      result{
          id
          email
          isSuperAdmin
          roleId
          createdAt
          updatedAt
          adminRole {
              id
              privileges
          }
      }
      status
      errorMessage
  }
}`;


export const getAllAdminUsersQuery = gql`
query getAllAdminUsers($currentPage: Int) {
  getAllAdminUsers(currentPage: $currentPage){
    count
    results{
      id
      email
      isSuperAdmin
      roleId
      createdAt
      updatedAt
      adminRole {
        id
        name
        description
        createdAt
        updatedAt
        privileges
      }
    }
  }
  }`;

export const adminLoginQuery = gql`
query (
  $email: String!,
  $password: String!) {
  adminUserLogin (
      email: $email,
      password: $password
  ) {
      status
      token
      isSuperAdmin
      expiresIn
      errorMessage
  }
}`;

export const adminUserLogoutQuery = gql`
query {
    adminUserLogout {
        status
    }
  }`;

export const getSiteSettingsQuery = gql`
  query getSiteSettings ($type: String){
      getSiteSettings(type: $type){
        results{
          name
          value
        }
        status
        errorMessage
      }
    }`;

export const updateHomePageCategoryMutation = gql`
    mutation ($homePageCategoryList: categoryListInputType!,$dynamicTopFeatureSettings:[dynamicTopFeaturesSettingsInput]!) {
        updateHomePageCategory (homePageCategoryList: $homePageCategoryList,dynamicTopFeatureSettings:$dynamicTopFeatureSettings) {
        status
        errorMessage
        }
    }`;

export const updateHomePageCityMutation = gql`
    mutation updateHomePageCity (
        $citySectionTitle1: String
        $citySectionContent1: String
        $dynamicCatogeryTitle: [dynamicHomePageSettingsInput]
      ) {
        updateHomePageCity (
          citySectionTitle1: $citySectionTitle1
          citySectionContent1: $citySectionContent1
          dynamicCatogeryTitle: $dynamicCatogeryTitle
        ) {
          status
          errorMessage
        }}`;


export const updateHomePageFooterMutation = gql`
mutation updateHomePageFooter (
    $footerLogo1: String
    $footerLogo2: String
    $footerLogo3: String
    $footerLogo4: String
    $footerTitle1: String
    $footerContent1: String
    $footerLink1: String
    $footerLink2: String
    $footerLink3: String
    $footerLink4: String
    $footerLinkName1: String
    $footerLinkName2: String
    $footerLinkName3: String
    $footerLinkName4: String
    $footerLinkTitle: String
    $footerBottom: String
    $dynamicFooterSettings:[dynamicHomePageSettingsInput]
  ) {
    updateHomePageFooter (
      footerLogo1: $footerLogo1
      footerLogo2: $footerLogo2
      footerLogo3: $footerLogo3
      footerLogo4: $footerLogo4
      footerTitle1: $footerTitle1
      footerContent1: $footerContent1
      footerLink1: $footerLink1
      footerLink2: $footerLink2
      footerLink3: $footerLink3
      footerLink4: $footerLink4
      footerLinkName1: $footerLinkName1
      footerLinkName2: $footerLinkName2
      footerLinkName3: $footerLinkName3
      footerLinkName4: $footerLinkName4
      footerLinkTitle: $footerLinkTitle
      footerBottom: $footerBottom,
      dynamicFooterSettings:$dynamicFooterSettings
    ) {
      status
      errorMessage
    }
  }`;

export const updateHomePageHomeMutation = gql`
mutation updateHomePageHome (
    $homeSectionImage1: String
    $homeSectionImage2: String
    $homeSectionImage3: String
    $homeSectionImage4: String
    $homeSectionImage5: String
    $homeSectionImage6: String
    $homeSectionImage7: String
    $homeSectionImage8: String
    $homeSectionButton1: String
    $homeSectionTitle1: String
    $homeSectionDescription1:String
    $dynamicHomeBannerTitle: [dynamicHomePageSettingsInput]
  ) {
    updateHomePageHome (
      homeSectionImage1: $homeSectionImage1
      homeSectionImage2: $homeSectionImage2
      homeSectionImage3: $homeSectionImage3
      homeSectionImage4: $homeSectionImage4
      homeSectionImage5: $homeSectionImage5
      homeSectionImage6: $homeSectionImage6
      homeSectionImage7: $homeSectionImage7
      homeSectionImage8: $homeSectionImage8
      homeSectionButton1: $homeSectionButton1
      homeSectionTitle1: $homeSectionTitle1
      homeSectionDescription1: $homeSectionDescription1
      dynamicHomeBannerTitle: $dynamicHomeBannerTitle
    ) {
      status
      errorMessage
    }
  }`;

export const updateHomePageSafetyMutation = gql`
mutation updateHomePageSafety (
    $safetyGridImage1: String
    $safetyGridImage2: String
    $safetyGridImage3: String
    $safetyGridTitle1: String
    $safetyGridContent1: String
    $safetyGridLink1: String
    $safetyGridLink2: String
    $safetyGridImage4: String
    $dynamicAppSettings:[dynamicHomePageSettingsInput]
  ) {
    updateHomePageSafety (
      safetyGridImage1: $safetyGridImage1
      safetyGridImage2: $safetyGridImage2
      safetyGridImage3: $safetyGridImage3
      safetyGridTitle1: $safetyGridTitle1
      safetyGridContent1: $safetyGridContent1
      safetyGridLink1: $safetyGridLink1
      safetyGridLink2: $safetyGridLink2
      safetyGridImage4: $safetyGridImage4
      dynamicAppSettings:$dynamicAppSettings
    ) {
      status
      errorMessage
    }
  }`;

export const updateHomePageSignupMutation = gql`
  mutation updateHomePageSignup (
      $signupGridImage1: String
      $signupGridImage2: String
      $signupGridImage3: String
      $signupGridTitle1: String
      $signupGridContent1: String
      $signupGridLink1: String
      $signupGridLink2: String
      $signupGridImage4: String
      $dynamicAppSettings:[dynamicHomePageSettingsInput]
    ) {
      updateHomePageSignup (
        signupGridImage1: $signupGridImage1
        signupGridImage2: $signupGridImage2
        signupGridImage3: $signupGridImage3
        signupGridTitle1: $signupGridTitle1
        signupGridContent1: $signupGridContent1
        signupGridLink1: $signupGridLink1
        signupGridLink2: $signupGridLink2
        signupGridImage4: $signupGridImage4
        dynamicAppSettings:$dynamicAppSettings
      ) {
        status
        errorMessage
      }
    }`;

export const updateMobileSettingsMutation = gql`
    mutation updateMobileSettings(
        $appForceUpdate: String
        $userAndroidVersion: String
        $userIosVersion: String
        $partnerAndroidVersion: String
        $partnerIosVersion: String,
        $stripePublishableKey: String,
        $allowableDistace: String,
        $allowedServices: String
        $notificationInterval: String				
        $sleepPartnerAndroid: String
        $sleepPartnerios: String
        $contactPhoneNumber: String
        $contactEmail: String
        $maximumEmergencyContact: String
        $duration: String
        $job: String
        $photo: String
        $description: String
        $estimatedPrice: String,
        $location: String
        $requestTimeTone: String
        $isRequestTimerToneEnable: String
        $openAppOnRequest: String
        $requestToneFile: String,
        $defaultScheduleInterval: String
        $addtionalWorkInterval: String,
        $randomProviderSelection:String
        $preferredProviderSelection:String,
        $maximumProviders:String
        $userAppAndroidMapAPIKey:String,
        $serviceProviderAppAndroidMapAPIKey:String
        $userAppIosMapAPIKey: String,
        $serviceProviderAppIosMapAPIKey: String,
        $whatsApp: String,
        $oneTimeVerification: String,
        $oneTimeVerificationValue: String,
        $deferredBackgroundCheck: String
        ) {
            updateMobileSettings(
            appForceUpdate: $appForceUpdate
            userAndroidVersion: $userAndroidVersion
            userIosVersion: $userIosVersion
            partnerAndroidVersion: $partnerAndroidVersion
            partnerIosVersion: $partnerIosVersion,
            stripePublishableKey: $stripePublishableKey,
            allowableDistace: $allowableDistace,
            allowedServices: $allowedServices,
            notificationInterval: $notificationInterval,
            sleepPartnerAndroid: $sleepPartnerAndroid,
            sleepPartnerios: $sleepPartnerios,
            contactPhoneNumber: $contactPhoneNumber,
            contactEmail: $contactEmail,
            maximumEmergencyContact: $maximumEmergencyContact,
            duration: $duration,
            job: $job,
            photo: $photo,
            description: $description,
            estimatedPrice: $estimatedPrice,
            location: $location
            requestTimeTone: $requestTimeTone
            isRequestTimerToneEnable: $isRequestTimerToneEnable
            openAppOnRequest: $openAppOnRequest
            requestToneFile: $requestToneFile
            defaultScheduleInterval: $defaultScheduleInterval
            addtionalWorkInterval: $addtionalWorkInterval
            randomProviderSelection:$randomProviderSelection
            preferredProviderSelection:$preferredProviderSelection
            maximumProviders:$maximumProviders
            userAppAndroidMapAPIKey:$userAppAndroidMapAPIKey
            serviceProviderAppAndroidMapAPIKey:$serviceProviderAppAndroidMapAPIKey
            userAppIosMapAPIKey: $userAppIosMapAPIKey
            serviceProviderAppIosMapAPIKey: $serviceProviderAppIosMapAPIKey
            whatsApp:$whatsApp
            oneTimeVerification: $oneTimeVerification
            oneTimeVerificationValue: $oneTimeVerificationValue
            deferredBackgroundCheck: $deferredBackgroundCheck
            ){
              status
              errorMessage
            }
        }`;

export const updateToneMutation = gql`
mutation updateTone {
    updateTone {
    status
    }
  }`;

export const updateSiteSettingsMutation = gql`
  mutation updateSiteSettings(
      $siteName: String,
      $siteTitle: String,
      $metaDescription: String, 
      $facebookLink: String,
      $twitterLink: String,
      $instagramLink: String,
      $metaKeyword: String,
      $homeLogo: String,
      $youtubeLink: String,
      $favicon: String,
      $ogImage: String,
      $logoText: String,
      ) {
          updateSiteSettings(
          siteName: $siteName
          siteTitle: $siteTitle
          metaDescription: $metaDescription
          facebookLink: $facebookLink
          twitterLink: $twitterLink
          instagramLink: $instagramLink
          metaKeyword: $metaKeyword
          homeLogo: $homeLogo
          youtubeLink: $youtubeLink
          favicon: $favicon
          ogImage: $ogImage
          logoText: $logoText
          ){
          status
          errorMessage
        }
      }` ;



export const updateStaticPageMutation = gql`
      mutation updateStaticPage(
        $id: Int,
        $content: String,
        $metaTitle: String,
        $metaDescription: String,
        $pageBanner: String,
        $dynamicStaticContent:[dynamicStaticContentInput]
      ) {
        updateStaticPage(
          id: $id,
          content: $content,
          metaTitle: $metaTitle,
          metaDescription: $metaDescription,
          pageBanner: $pageBanner,
          dynamicStaticContent:$dynamicStaticContent
        ) {
            status
            errorMessage
        }
      }`;

export const getEditStaticPageQuery = gql`query getEditStaticPage ($id: Int!) {
        getEditStaticPage (id: $id) {
            result{
              id
              pageName
              content
              metaTitle
              metaDescription
              pageBanner
              createdAt
            }  
        }
      }`;


export const getContentPageQuery = `
      query getContentPage ($pageUrl: String) {
        getContentPage (pageUrl: $pageUrl) {
            status
            errorMessage
            result{
            id
            metaTitle
            metaDescription
            pageUrl
            pageTitle
            content
            isEnable
            pageBanner
            dynamicContent {
                id
                contentId
                language
                content
            }
            }
        }
    }`;

export const checkUserExists = gql`
    mutation checkUserExists($phoneDialCode: String!,$phoneNumber: String! ) {
      checkUserExists( phoneDialCode: $phoneDialCode,phoneNumber: $phoneNumber) {
        status
        errorMessage
        result {
          id
          email
          userType
          phoneNumber
          phoneDialCode
          walletBalance
          cardLast4
          cardBrand
          cardPaymentMethodId
          profile {
            firstName
            lastName
          }
        }
      }
    }
    `;



export const getBookingSubCategories = gql`
    query getBookingSubCategories($categoryId: Int!, $lat: Float!, $lng: Float!) {
      getBookingSubCategories(categoryId: $categoryId, lat: $lat, lng: $lng) {
        status
        errorMessage
        results {
          id
          name
          description
          image
          status
          createdAt
          updatedAt
          categoryData {
            name
            pricingType
            travellingPrice
            userServiceFeeValue
            currency
          }
          pricingDetails {
            multiplierValue
            convertBasePrice
          }
        }
      }
    }`;

export const getAllSmsMethod = gql` 
query {
  getAllSmsMethod {
      status
      errorMessage
      results {
          id
          name
          status
      }
  }
}`;

export const getConfigSettingsData = `query getConfigSettings($name: String) {
  getConfigSettings(name: $name) {
      title
      name
      encryptValue
  }
}`;

export const getStripeSettings = gql`
  {
    getStripeSettings {
      errorMessage
      status
      name
      value
    }
  }
`;

export const uploadReviewImageMutation = gql`
  mutation uploadReviewImageMutation($orderId: Int!, $picture: String!) {
    uploadReviewImageMutation(orderId: $orderId, picture: $picture) {
      status
    }
  }
`;

export const removeReviewImage = gql`
  mutation removeReviewImage($orderId: Int!, $picture: String!) {
    removeReviewImage(orderId: $orderId, picture: $picture) {
      status
    }
  }
`;

export const getActiveSmsMethods = gql` 
query {
  getActiveSmsMethods {
      status
      errorMessage
      results {
          id
          name
          status
      }
  }
}`;

export const updateOnBoardingContent = gql` 
mutation updateOnBoardingContent(
      $id: Int
      $pageTitle: String
      $content: String
      $status: String
    ){
      updateOnBoardingContent(
        id: $id
        pageTitle: $pageTitle
        content: $content
        status: $status
      ){
        status
        errorMessage
        result {
          id
          pageTitle
          content
          status
        }
        isUpdate
      }
    }
`;

export const getAllOnBoardingContent = gql` 
query getAllOnBoardingContent($currentPage: Int) {
  getAllOnBoardingContent(currentPage: $currentPage) {
    status
    errorMessage
    count
    results {
      id
      pageTitle
      content
      status
    }
  }
}`;

export const getOnBoardingContent = gql` 
query getOnBoardingContent ($id: Int) {
  getOnBoardingContent (id: $id) {
      status
      errorMessage
      result {
          id
          pageTitle
          content
          status
      }
  }
}`;

export const deleteOnBoardingContent = gql`
mutation deleteOnBoardingContent($id:Int!) {
  deleteOnBoardingContent(id:$id) {
    status
    errorMessage
  }
}`;